import { render, staticRenderFns } from "./BackendErrors.vue?vue&type=template&id=0bfe0610&"
import script from "./BackendErrors.vue?vue&type=script&lang=js&"
export * from "./BackendErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports